import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { MijnFNVPageContext } from '../pages/helpers/MijnFNVPageContext';
import Select from 'react-select';
import fetch from 'cross-fetch';
import { connect } from 'react-redux';
import * as actions from '../../actions/FormActions';
import { storeAlert, clearAlert } from '../../actions/AlertActions';
import { Grid } from '../../templates/Grid';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import {
  MIJNFNV_MONTLYFEE_URL,
  IDEAL_STATUS_URL,
  MIJNFNV_STARTTRANSACTION_URL
} from '../../constants/Constants';
import { getAllUrlParams } from '../../../jslibs/urlparams';
import { storeRenderFormTrigger } from '../../actions/RenderFormTriggerActions';
import { getResourceString } from '../../kentico/resource-strings';

export interface MijnFNVPaymentProps {
  title: string;
  userId: string;
  totalAmountText: string;
  payXMonthContributionText: string;
  payButtonText: string;
  payButtonUrl: string;
  intro: string;
  openContributionText: string;
  noOpenContributionText: string;
  contributionTitle: string;
  contributionInformation: string | null;
  payInAdvanceTitle: string;
  payInAdvanceInformation: string | null;

  showErrorOnApiError: any;
  storeAlert: (Title: string, Code: string, Link: string, LinkText: string) => void;
  clearAlert: () => void;

  storeRenderFormTrigger: (triggerName: string) => void;
}

const mapStateToProps = (state: any) => {
  return {
    userId: state.user.userId
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    showErrorOnApiError: error => {
      dispatch(actions.showErrorOnApiError(error));
    },
    storeAlert: (title, type, link, linkText) => {
      dispatch(storeAlert(title, type, link, linkText));
    },
    clearAlert: () => {
      dispatch(clearAlert());
    },
    storeRenderFormTrigger: (triggerName: string) => {
      dispatch(storeRenderFormTrigger(triggerName));
    }
  };
};

export interface MijnFNVPaymentState {
  numberOfMonths: number;
  montlyAmount: number;
  idealStatusDescription: string;
  maxMonths: number;
  redirectUrl: string;
  doRedirect: boolean;
  transactionGuid: string;
  customerTransactionDescription: string;
  hasError: boolean;
  paymentMessage: string;
  openMembershipFee: number;
  isIdealEnabled: boolean;
  isSendingData: boolean;
  openContributions: any[];
  activeRow: number;
  openContributionAmount: string;
  openContributionAmountAsNumber: number;
  isPayNL: boolean;
  isFirstPopoverOpen: boolean;
  isSecondPopoverOpen: boolean;
}

export interface IOpenstaandeContributie {
  Betaaloverzicht: any[];
}

export interface IMonthlyFee {
  MaandcontributieBedrag: number;
  AantalMaandenVooruitbetalen: number;
  OpenstaandeContributie: number;
  IdealIsEnabled: boolean;
  OpenstaandeContributies: IOpenstaandeContributie;
  BetaalwijzeLid: string;
  MeerDanEenMaandAchterstand: boolean;
}

export interface IIdealNotification {
  Title: string;
  Type: string;
  Code: string;
  Link: string;
  LinkText: string;
}

function betaalwijzeIsIncasso(contributionInfo: IMonthlyFee) {
  return contributionInfo.BetaalwijzeLid === 'INC';
}

const styles = {
  clearIndicator: () => undefined,
  container: () => undefined,
  control: () => undefined,
  dropdownIndicator: () => undefined,
  groupHeading: () => undefined,
  indicatorsContainer: () => undefined,
  indicatorSeparator: () => undefined,
  input: () => undefined,
  loadingIndicator: () => undefined,
  loadingMessage: () => undefined,
  menu: () => undefined,
  menuList: () => undefined,
  multiValue: () => undefined,
  multiValueLabel: () => undefined,
  multiValueRemove: () => undefined,
  noOptionsMessage: () => undefined,
  option: () => undefined,
  placeholder: () => undefined,
  singleValue: () => undefined,
  valueContainer: () => undefined
};

export class MijnFNVPaymentContained extends React.Component<
  MijnFNVPaymentProps,
  MijnFNVPaymentState
> {
  state = {
    numberOfMonths: 0,
    montlyAmount: 0,
    idealStatusCode: '',
    idealStatusDescription: '',
    maxMonths: 0,
    redirectUrl: '',
    doRedirect: false,
    transactionGuid: '',
    customerTransactionDescription: '',
    hasError: false,
    paymentMessage: '-',
    openMembershipFee: 0,
    isIdealEnabled: true,
    isSendingData: false,
    openContributions: [],
    activeRow: -1,
    openContributionAmount: '',
    openContributionAmountAsNumber: 0,
    isPayNL: false,
    isFirstPopoverOpen: false,
    isSecondPopoverOpen: false
  };

  formatAmountAsCurrencyInEuros(amount: number) {
    if ((amount as any) === undefined) {
      return '';
    }
    return (
      '€ ' +
      amount
        .toFixed(2)
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    );
  }

  getPaymentMessage = (contributionInfo: IMonthlyFee) => {
    if (contributionInfo.OpenstaandeContributie == 0) {
      return this.props.noOpenContributionText;
    }

    let contributionText = this.props.openContributionText;

    return (contributionText || '').replace(
      '{0}',
      this.formatAmountAsCurrencyInEuros(contributionInfo.OpenstaandeContributie)
    );
  }

  componentDidMount() {
    let urlParams = getAllUrlParams(this.context.search);

    let fetchUrl = IDEAL_STATUS_URL;
    if (urlParams.statusCode != null)
    {
      fetchUrl += '/' +
        this.props.userId + 
        '?trid=' + 
        urlParams.id +
        '&statusAction=' +
        urlParams.statusAction +
        '&statusCode=' +
        urlParams.statusCode;
    }
    else{
      fetchUrl += '/' +
        this.props.userId +
        '?ec=' +
        urlParams.ec +
        '&trxid=' +
        urlParams.trxid;
    }

    fetch(fetchUrl)
      .then(response => {
        if (response.status >= 300) {
          return { error: true };
        } else {
          return response.json();
        }
      })
      .then(json => {
        if (!!(json as any).error) {
          this.props.showErrorOnApiError();
          this.setState({ hasError: true });
          return;
        }

        const notifications: IIdealNotification[] = json as IIdealNotification[];
        this.props.clearAlert();
        notifications.map(notification => {
          this.props.storeAlert(
            notification.Title,
            notification.Type,
            notification.Link,
            notification.LinkText
          );
        });

        fetch(MIJNFNV_MONTLYFEE_URL + '/' + this.props.userId)
          .then(response => {
            if (response.status >= 300) {
              return { error: true };
            } else {
              return response.json();
            }
          })
          .then(json => {
            if (!!(json as any).error) {
              this.props.showErrorOnApiError();
              this.setState({ hasError: true });
              return;
            }

            // renderTrigger: ideal-api-ready

            const contributionInfo: IMonthlyFee = json as IMonthlyFee;
            this.setState(
              {
                paymentMessage: this.getPaymentMessage(contributionInfo),
                montlyAmount: contributionInfo.MaandcontributieBedrag as number,
                maxMonths: contributionInfo.AantalMaandenVooruitbetalen as number,
                openMembershipFee: contributionInfo.OpenstaandeContributie as number,
                isIdealEnabled: contributionInfo.IdealIsEnabled as boolean,
                openContributions: contributionInfo.OpenstaandeContributies.Betaaloverzicht,
                openContributionAmount: this.formatAmountAsCurrencyInEuros(
                  contributionInfo.OpenstaandeContributie
                ),
                openContributionAmountAsNumber: contributionInfo.OpenstaandeContributie
              },
              () => {
                this.props.storeRenderFormTrigger('ideal-api-ready');
              }
            );
          });
      });
  }

  onSubmit = (event: any) => {
    event.preventDefault();

    if (this.state.numberOfMonths === 0 && this.state.openMembershipFee == 0) {
      return false;
    }
    this.setState({ isSendingData: true });

    let self = this;
    fetch(MIJNFNV_STARTTRANSACTION_URL + '/' + this.props.userId, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        AantalMaandenVooruitbetalen: this.state.numberOfMonths,
        ReturnUrl: (window as any).location.href.split('?')[0]
      })
    })
      .then(response => {
        this.setState({ isSendingData: false });
        if (response.status >= 300) {
          return { error: true, reply: response.json() };
        } else {
          return response.json();
        }
      })
      .then(json => {
        if (!!(json as any).error) {
          json.reply.then(reply => {
            // Pass error-reply from server to error-popup
            this.props.showErrorOnApiError(reply);
          });
          return;
        }
        const payNLUrl = (json as any).Url;
        const isPayNL = payNLUrl.includes('https');
        this.setState({
          isPayNL : isPayNL,
          doRedirect: true,
          redirectUrl: isPayNL ? (json as any).Url : this.props.payButtonUrl,
          transactionGuid: (json as any).TransactionGuid,
          customerTransactionDescription: (json as any).CustomerDescription
        });
      });

    return false;
  }

  isPaymentAllowed() {
    return (
      (this.state.numberOfMonths > 0 || this.state.openMembershipFee > 0) &&
      this.state.isIdealEnabled
    );
  }

  getTotalPaymentAmount() {
    return this.state.numberOfMonths * this.state.montlyAmount + this.state.openMembershipFee;
  }

  render() {
    if (this.state.doRedirect && this.state.redirectUrl != '')
    {
      if (this.state.isPayNL){
        location.href = this.state.redirectUrl;
        return;
      }

      // TODO: Can be removed after 01-10-2024
      if (this.state.transactionGuid != '') {
      return (
        <Redirect
          to={{
            pathname: this.state.redirectUrl,
            search: 'transactionGuid=' + this.state.transactionGuid,
            state: {
              transactionGuid: this.state.transactionGuid,
              customerTransactionDescription: this.state.customerTransactionDescription
            }
          }}
        />
      );
    }
  }

    if (this.state.hasError) {
      return <></>;
    }

    if (!this.state.isIdealEnabled) {
      return <></>;
    }

    let payXMonthContributionTextParts = this.props.payXMonthContributionText.split('{0}');

    const beforeXMonthLabel: string =
      payXMonthContributionTextParts.length > 0 ? payXMonthContributionTextParts[0] : '';
    const afterXMonthLabel: string =
      payXMonthContributionTextParts.length > 1 ? payXMonthContributionTextParts[1] : '';

    let options: any[] = [];

    let loop = 0;
    while (loop <= this.state.maxMonths) {
      options.push({
        value: loop,
        label: loop
      });
      loop++;
    }

    const openstaandeContributies = {
      openstaandeContributies: this.state.openContributions
    };
    const openstaandeContributiesFormDefinition = {
      name: 'openstaandeContributies',
      noResults: '',
      groupByColumnName: '',
      groupByColumnTitle: '',
      gridDetailsColumns: [],
      gridColumns: [
        {
          name: 'InvoiceYear',
          title: getResourceString("Form.Payment.Year"),
          visible: true,
          cssClasses: 'col-12 col-md-1'
        },
        {
          name: 'InvoiceMonth',
          title: getResourceString("Form.Payment.Month"),
          visible: true,
          cssClasses: 'col-12 col-md-2'
        },
        {
          name: 'Betalingskenmerk',
          title: getResourceString("Form.Payment.PaymentIdentifier"),
          visible: true,
          cssClasses: 'col-12 col-md-4'
        },
        {
          name: 'Status',
          title: getResourceString("Form.Payment.PaymentState"),
          visible: true,
          cssClasses: 'col-12 col-md-3',
          addValueAsCssClass: true
        },
        {
          name: 'UnpaidAmount',
          title: getResourceString("Form.Payment.Outstanding"),
          visible: true,
          cssClasses: 'col-12 col-md-2 justify-content-end text-md-right',
          dataType: 'currency',
          decimalSeparator: ',',
          currencyFormat: '€ {value}'
        }
      ]
    };

    return (
      <>
        <div className={'mijn-fnv-form__content-block mijn-fnv-form__payment-block'}>
          <h3>{this.props.title}</h3>
          <p>{this.props.intro}</p>
          {this.state.paymentMessage != '' ? (
            <div className="mijn-fnv__payment-ideal-status-container-wrapper">
              <span className='mijn-fnv__popover-title'>
                {this.props.contributionTitle}
                {this.props.contributionInformation !== null && this.props.contributionInformation !== '' &&
                  <span className="mijn-fnv__popover-button form-control__popover-icon icon icon-information" onClick={() => this.setState({isFirstPopoverOpen: !this.state.isFirstPopoverOpen})} title="Klik hier om de pop-up te openen">
                    {this.state.isFirstPopoverOpen && <span className="form-control__popover">{this.props.contributionInformation}</span>}
                  </span>
                }
              </span>
              <Accordion
                activeKey={this.state.activeRow.toString()}
                onSelect={data => {
                  this.setState({ activeRow: parseInt(data) });
                }}
              >
                <div
                  className={
                    'mijn-fnv__payment-ideal-status-container ' +
                    (this.state.activeRow == 99999
                      ? 'mijn-fnv__payment-ideal-status-container--open '
                      : '') + 
                    (this.state.openContributionAmountAsNumber > 0 
                      ? 'mijn-fnv__payment-ideal-status-container--dark ' 
                      : '')
                  }
                >
                  <span className="mijn-fnv__payment-ideal-status">
                    {this.state.paymentMessage}
                  </span>
                  {this.state.openContributionAmountAsNumber > 0 && <>
                    <span className="mijn-fnv__payment-ideal-open-amount">
                      {this.state.openContributionAmount}
                    </span>
                    <Accordion.Toggle
                      as={Button}
                      variant="link"
                      eventKey={'99999'}
                      onClick={event => {
                        if (this.state.activeRow == 99999) {
                          this.setState({ activeRow: -1 });
                        }
                      }}
                    >
                      <span className="icon icon-open-chevron-down"></span>
                    </Accordion.Toggle>
                  </>}
                </div>
                {this.state.openContributionAmountAsNumber > 0 && <Accordion.Collapse
                  eventKey={'99999'}
                  className="mijn-fnv-form__payment-block-open-contributions"
                >
                  <Grid
                    form={openstaandeContributies}
                    formFieldDefinition={openstaandeContributiesFormDefinition}
                  ></Grid>
                </Accordion.Collapse>}
              </Accordion>
            </div>
          ) : null}
          {(options.length > 0 || this.state.openContributionAmountAsNumber > 0) && 
          <form className="form mijn-fnv-form__payment-form" onSubmit={this.onSubmit}>
            {options.length > 0 && <>
              <span className='mijn-fnv__popover-title'>
                {this.props.payInAdvanceTitle}
                {this.props.payInAdvanceInformation !== null && this.props.payInAdvanceInformation !== '' &&
                  <span className="mijn-fnv__popover-button form-control__popover-icon icon icon-information" onClick={() => this.setState({isSecondPopoverOpen: !this.state.isSecondPopoverOpen})} title="Klik hier om de pop-up te openen">
                    {this.state.isSecondPopoverOpen && <span className="form-control__popover">{this.props.payInAdvanceInformation}</span>}
                  </span>
                }
              </span>
              <div className="mijn-fnv__payment-months-select-container">              
                  <label className="mijn-fnv__payment-months-select-label-before">
                    {beforeXMonthLabel}
                  </label>
                  <Select
                    placeholder="0"
                    options={options}
                    id="id"
                    styles={styles}
                    classNamePrefix="form-dropdown"
                    className="form-control form-dropdown__container mijn-fnv__payment-months-select"
                    onChange={(value: any) => {
                      this.setState({ numberOfMonths: value.value });
                    }}
                  />
                  <span className="mijn-fnv__payment-months-select-label-after">
                    {afterXMonthLabel}
                  </span>
                  <span className="mijn-fnv__payment-total-amount">
                    {this.formatAmountAsCurrencyInEuros((this.state.montlyAmount * this.state.numberOfMonths))}
                  </span>
              </div>
            </>}
              <div className="mijn-fnv__payment-total-amount-container">
                <span className="mijn-fnv__payment-total-label">{this.props.totalAmountText}:</span>
                <span className="mijn-fnv__payment-total-amount">
                  {this.formatAmountAsCurrencyInEuros(this.getTotalPaymentAmount())}
                </span>
              </div>
            {!this.state.hasError && (
              <div className="mijn-fnv__payment-submit-container">
                {this.state.isSendingData && <span className="spinner spinner-border"></span>}
                <button
                  className={
                    'btn btn-success ' +
                    (this.isPaymentAllowed() && !this.state.isSendingData ? '' : 'disabled')
                  }
                  disabled={!this.isPaymentAllowed() || this.state.isSendingData}
                >
                  {this.props.payButtonText}
                </button>
              </div>
            )}
          </form>}
        </div>
      </>
    );
  }

  static contextType = MijnFNVPageContext;
  context!: React.ContextType<typeof MijnFNVPageContext>;
}

export const MijnFNVPayment = connect(
  mapStateToProps,
  mapDispatchToProps
)(MijnFNVPaymentContained);
